export const itPlanetwin365 = {
  modal: {
    geolocation: {
      content:
        'Planetwin365.it sta per chiederti di accedere alla tua posizione per una migliore fruizione del servizio.',
      title: 'Geolocalizzazione Planetwin365',
    },
  },
  namespaceTest: 'Ciao Planetwin365',
};
